<div
  class="@container flex flex-row flex-wrap items-center justify-between gap-2 mb-4 mt-4"
  role="toolbar"
  aria-label="Toolbar calendario"
>
  @if (showCollaboratoreField()) {
    <siat-select-field
      class="min-w-48 flex-1 max-w-64"
      [items]="collaboratoriItems()"
      [formGroup]="collaboratoreFormGroup()"
      [controlName]="collaboratoreControlName()"
      [showLabel]="true"
      [showSelectedIcon]="true"
      [ariaLabel]="'Collaboratore'"
      label="Collaboratore"
      placeholder="Seleziona un calendario tuo o di un tuo collaboratore"
    />
  }

  <div class="flex items-center flex-nowrap gap-2 shrink-0">
    <button
      matIconButton
      class="shrink-0"
      aria-label="Periodo precedente"
      matTooltip="Periodo precedente"
      (click)="navigate.emit('prev')"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>
    <button
      matButton="tonal"
      class="shrink-0 whitespace-nowrap"
      aria-label="Vai a oggi"
      matTooltip="Vai a oggi"
      (click)="navigate.emit('today')"
    >
      Oggi
    </button>
    <button
      matIconButton
      class="shrink-0"
      aria-label="Periodo successivo"
      matTooltip="Periodo successivo"
      (click)="navigate.emit('next')"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <div class="relative flex min-w-0">
    <button
      type="button"
      class="flex items-center gap-1.5 min-w-0 rounded-full! overflow-hidden"
      [matTooltip]="'Vai a una data specifica: ' + periodLabel()"
      [attr.aria-label]="
        'Vai a una data specifica, periodo corrente ' + periodLabel()
      "
      (click)="periodPicker.open()"
      matButton="outlined"
    >
      <span
        class="min-w-0 flex-1 text-md font-normal capitalize whitespace-nowrap overflow-hidden text-ellipsis text-on-surface-variant"
        >{{ periodLabel() }}</span
      >
      <mat-icon aria-hidden="true" class="text-on-surface-variant shrink-0"
        >event</mat-icon
      >
    </button>
    <input
      class="absolute bottom-0 left-0 w-0 h-0 p-0 m-0 border-none opacity-0 pointer-events-none"
      [matDatepicker]="periodPicker"
      aria-hidden="true"
      aria-label="Seleziona periodo"
      tabindex="-1"
      (dateChange)="onDateChange($event.value)"
    />
    <mat-datepicker
      #periodPicker
      [startView]="datePickerGranularity() === 'month' ? 'multi-year' : 'month'"
      (monthSelected)="onMonthSelected($event, periodPicker)"
    />
  </div>

  <div class="flex items-center flex-nowrap shrink-0 gap-2">
    @if (viewOptions().length > 0) {
      <mat-button-toggle-group
        class="calendar-toolbar-view-toggle shrink-0"
        aria-label="Seleziona vista calendario"
        [value]="viewMode()"
        [hideSingleSelectionIndicator]="true"
        (change)="viewMode.set($event.value)"
      >
        @for (opt of viewOptions(); track opt.value) {
          <mat-button-toggle
            [value]="opt.value"
            [attr.aria-label]="opt.label"
            [matTooltip]="opt.label"
          >
            @if (opt.icon) {
              <mat-icon class="m-0!">{{ opt.icon }}</mat-icon>
            }
            <span class="@max-[70rem]:hidden">{{ opt.label }}</span>
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    }

    @if (secondaryViewOptions().length > 0) {
      <mat-button-toggle-group
        class="calendar-toolbar-view-toggle shrink-0"
        aria-label="Seleziona periodo calendario"
        [value]="secondaryViewMode()"
        [hideSingleSelectionIndicator]="true"
        (change)="secondaryViewMode.set($event.value)"
      >
        @for (opt of secondaryViewOptions(); track opt.value) {
          <mat-button-toggle
            [value]="opt.value"
            [attr.aria-label]="opt.label"
            [matTooltip]="opt.label"
          >
            @if (opt.icon) {
              <mat-icon class="m-0!">{{ opt.icon }}</mat-icon>
            }
            <span class="@max-[70rem]:hidden">{{ opt.label }}</span>
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    }

    @if (showAddButton() && addButtonOptions().length > 0) {
      @if (addButtonOptions().length === 1) {
        <button
          mat-mini-fab
          class="shrink-0 special-action-fab"
          [attr.aria-label]="addButtonOptions()[0]"
          [matTooltip]="'Crea un nuovo evento nel calendario'"
          [disabled]="addButtonDisabled()"
          (click)="addNew.emit(addButtonOptions()[0])"
        >
          <mat-icon class="text-white!">add</mat-icon>
        </button>
      } @else {
        <button
          mat-mini-fab
          class="shrink-0 special-action-fab"
          aria-label="Nuovo"
          matTooltip="Crea un nuovo evento nel calendario"
          [matMenuTriggerFor]="addMenu"
          [disabled]="addButtonDisabled()"
        >
          <mat-icon class="text-white!">add</mat-icon>
        </button>
        <mat-menu #addMenu="matMenu">
          @for (option of addButtonOptions(); track option) {
            <button
              mat-menu-item
              (click)="addNew.emit(option)"
              [attr.aria-label]="'Add ' + option"
              type="menuitem"
            >
              {{ option }}
            </button>
          }
        </mat-menu>
      }
    }
  </div>
</div>
